@if (!sended) {
  <section class="no-auth-page">
    <header>
      <h3>Reset your password</h3>
      <h4>If you want to change your password, introduce your email here</h4>
    </header>
    <form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
      <div class="ht-form-item">
        <div class="ht-form-item-title">Email</div>
        <div class="ht-form-item-control">
          <ht-input
            label="Email"
            type="email"
            formControlName="email"
            [fullWidth]="true"
          ></ht-input>
        </div>
      </div>
      <div class="ht-form-actions">
        <button
          ht-button-primary
          type="submit"
          size="large"
          [fullWidth]="true"
          [isLoading]="isLoading"
        >
          Send email
        </button>
        <a
          ht-button-primary
          appearance="minimal"
          [fullWidth]="true"
          routerLink="/sign-in"
        >
          Back to Sign in
        </a>
      </div>
    </form>
  </section>
} @else {
  <section class="no-auth-page">
    <header>
      <h3>Check your email</h3>
    </header>
    <p>Thanks! We have sent an email that will enable you reset password.</p>
    @if (!resended) {
      <p>
        If you haven't received an email check your spam, or
        <a (click)="resendEmail()"> resend </a>
        email.
      </p>
    }
    @if (resended) {
      <p>Email has been sent again.</p>
    }
    <div class="ht-form">
      <div class="ht-form-actions">
        <a
          ht-button-primary
          appearance="minimal"
          routerLink="/sign-in"
          [fullWidth]="true"
        >
          Go back to Sign in
        </a>
      </div>
    </div>
  </section>
}
